import {
  ANALYTICS_WIDGET_FEATURE_KEY,
  isFeatureEnabled,
} from "@/features/chat-agent/feature-check";
import { ADMIN_ROLE, TSupplierRole } from "@/http";
import { TSupplierFeature } from "@/http/types/supplier";

export const hasPermission = (
  isCommercial: boolean,
  role: TSupplierRole | null,
  requiredPermissions: string[]
) => {
  if (role?.name === ADMIN_ROLE) {
    return true;
  }

  if (!isCommercial) {
    return true;
  }

  if (!requiredPermissions.length) {
    return true;
  }

  // Backward-compatible aliases for renamed permissions
  const aliases: Record<string, string[]> = {
    "route.users.list": ["route.commercials.list"],
  };

  const permissionsSet = new Set(role?.permissions ?? []);

  return requiredPermissions.every((permission) => {
    if (permissionsSet.has(permission)) return true;
    const legacy = aliases[permission] || [];
    return legacy.some((legacyKey) => permissionsSet.has(legacyKey));
  });
};

export const isAdmin = (isCommercial: boolean, role: TSupplierRole | null) => {
  if (!isCommercial) {
    return true;
  }

  if (role?.name === ADMIN_ROLE) {
    return true;
  }

  return false;
};

export const getDefaultRouteAfterLogin = (
  isCommercial: boolean,
  role: TSupplierRole | null,
  features?: TSupplierFeature[]
): string => {
  if (isFeatureEnabled(features, ANALYTICS_WIDGET_FEATURE_KEY)) {
    return "/super-agent";
  }

  if (!isCommercial) {
    return "/purchases";
  }

  const permissions = role?.permissions || [];

  if (permissions.includes("route.purchases.list")) {
    return "/purchases";
  }

  if (permissions.includes("route.quotes.list")) {
    return "/quotes";
  }

  return "/";
};
